import { graphql } from '~publish/graphql'

/**
 * What the queue card's Notes tooltip reads beside the unread Note count.
 * It comes from the same backend lookup as the unread Note count.
 */
export const PostUnreadMentionCount = graphql(/* GraphQL */ `
  fragment PostUnreadMentionCount on Post @_unmask {
    id
    collaborationNotesSummary {
      unreadMentionCount
    }
  }
`)
